/** Configurable ARO API client (`/api/aro` → auth :8100 `/aro`). */

async function req(path, { method = 'GET', body } = {}) {
  const res = await fetch(`/api/aro${path}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let detail = res.statusText;
    try {
      const j = await res.json();
      detail = j.detail || JSON.stringify(j);
    } catch {
      /* ignore */
    }
    const err = new Error(typeof detail === 'string' ? detail : JSON.stringify(detail));
    err.status = res.status;
    throw err;
  }
  return res.json();
}

const enc = encodeURIComponent;

/** PUT body for deal config: only writable fields (GET adds updatedBy/updatedAt). */
export function configBody(cfg) {
  const out = {};
  for (const k of ['mode', 'dealOverride', 'salvage']) if (cfg?.[k] != null) out[k] = cfg[k];
  return out;
}

/** Merge the configured ARO PV ($MM) into a desk deal package; returns pkg unchanged on failure/unknown. */
export async function withAroEstimate(pkg, dealId) {
  if (!pkg || !dealId) return pkg;
  try {
    const v = await aroApi.deal(dealId);
    const pv = aroPvForDesk(v?.resolved);
    if (pv == null) return pkg;
    return { ...pkg, assumptions: { ...(pkg.assumptions || {}), aroMM: pv, aroSource: v.resolved.sourceLabel } };
  } catch {
    return pkg;
  }
}

export const aroApi = {
  deck: () => req('/deck'),
  deal: (dealId) => req(`/deals/${enc(dealId)}`),
  setConfig: (dealId, body) => req(`/deals/${enc(dealId)}/config`, { method: 'PUT', body: configBody(body) }),
  setWell: (dealId, wellId, body) => req(`/deals/${enc(dealId)}/wells/${enc(wellId)}`, { method: 'PUT', body }),
  clearWell: (dealId, wellId) => req(`/deals/${enc(dealId)}/wells/${enc(wellId)}`, { method: 'DELETE' }),
};

/** Desk PV input: discounted ARO ($MM) when an estimate/override exists; null when unknown. */
export function aroPvForDesk(resolved) {
  if (!resolved || !resolved.known) return null;
  const pv = resolved.totals?.pvMM;
  return Number.isFinite(pv) ? pv : null;
}

export const MODE_LABELS = {
  d2d: 'D2D estimate (with overrides)',
  sellerMinimal: 'Seller states minimal (labeled $0)',
  none: 'None — fail closed',
};
